import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function TennisCourt(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M4.073 10.912a8.005 8.005 0 016.842-6.84c.002.03.006.058.01.086.05.307.075.623.075.945C11 8.362 8.364 11 5.116 11c-.326 0-.645-.026-.955-.077a1.024 1.024 0 00-.088-.01zm5.928 8.836a8.007 8.007 0 01-5.948-6.82c.348.048.703.072 1.063.072C9.472 13 13 9.463 13 5.103c0-.355-.024-.706-.07-1.05a8.003 8.003 0 017.026 7.1A7.987 7.987 0 0018.399 11c-4.651 0-8.324 3.963-8.398 8.748zm.658 2.163a.995.995 0 00.634.064c.233.017.47.025.707.025 5.277 0 9.6-4.088 9.974-9.27a.994.994 0 00.019-.35c.005-.126.007-.253.007-.38 0-5.523-4.477-10-10-10S2 6.477 2 12c0 5.068 3.77 9.256 8.659 9.91zm9.253-8.717A8.002 8.002 0 0112 20L12 19.895C12 16.025 14.925 13 18.4 13c.52 0 1.027.067 1.512.194z",
    clipRule: "evenodd"
  }));
}

export default TennisCourt;